import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';
import { Link } from 'react-router-dom';

export const StyledListHeader = styled(StyledDiv)`
  display: flex;
  width: 100%;
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  line-height: 30px;
`;

export const StyledHeaderItem = styled.span<{ isActiveList: boolean }>`
  flex: 1;
  text-align: center;
  cursor: pointer;
  color: ${({ theme, isActiveList }): string =>
    isActiveList ? theme.colors.secondaryGreen : theme.colors.normalText};
  :not(:last-of-type) {
    border-left: ${({ theme }): string => theme.borders[0]};
    border-color: ${({ theme }): string => theme.colors.border};
  }
`;

export const StyledCreditHistoryLink = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-radius: ${({ theme }): string => theme.radii.xl};
  padding: 0 14px;
  direction: rtl;
  color: ${({ theme }): string => theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[4]};
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  cursor: pointer;
`;
